import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { TotemWidget } from '../totem-widget';
import { LocalizationService } from 'pg-lib/services/localization.service';

@Component({
    selector: 'app-totem-widget-activities',
    templateUrl: './totem-widget-activities.component.html',
    styleUrls: ['./totem-widget-activities.component.scss'],
    standalone: false
})
export class TotemWidgetActivitiesComponent extends TotemWidget implements OnInit {
    size: 'lg' = 'lg';

    @ViewChild('activitiesList', { static: false }) activitiesList: ElementRef<HTMLElement>;

    constructor(public elementRef: ElementRef, private localizationService: LocalizationService) {
        super(elementRef);
    }

    @Input() activityList: Array<{
        date: string;
        day?: number;
        location?: string;
        activities: Array<{
            time?: string;
            hour?: string;
            title: string;
            description?: string;
            duration?: number;
        }>;
    }>;

    ngOnInit(): void {
        super.ngOnInit();
    }

    getActivityTime(activity: { time?: string; hour?: string }) {
        return activity.time || activity.hour;
    }

    getRelativeDate(date: string|Date) {
        if (date != null) {
            const target = new Date(date);

            const checkDate = new Date();
            checkDate.setHours(0, 0, 0, 0);
            checkDate.setDate(checkDate.getDate() - 1);

            const relativeList = ['yesterday', 'today', 'tomorrow'];
            let count = 0;

            while (target.getTime() >= checkDate.getTime()) {
                checkDate.setDate(checkDate.getDate() + 1);

                if (target.getTime() < checkDate.getTime()) {
                    return this.localizationService.translate('totem-widget-activities.' + relativeList[count]);
                }

                count++;
                if (count >= relativeList.length) break;
            }
        }

        return '';
    }

    formatDuration(minutes: number) {
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;

        let result = '';
        if (hours > 0) {
            if (hours == 1) result += this.localizationService.translate('totem-widget-activities.hour');
            else result += this.localizationService.translate('totem-widget-activities.hours', { num: hours });
        }

        if (mins > 0) {
            if (result != '') result += this.localizationService.translate('totem-widget-activities.and');

            if (mins == 1) result += this.localizationService.translate('totem-widget-activities.minute');
            else result += this.localizationService.translate('totem-widget-activities.minutes', { num: mins });
        }

        return result;
    }

    scrollToDay(index: number) {
        const list = this.activitiesList?.nativeElement;
        if (!list || index == null || index < 0) return;

        const dayEl = list.children.item(index) as HTMLElement;
        if (!dayEl) return;

        const gutter = 15;
        const left = list.scrollLeft
            + (dayEl.getBoundingClientRect().left - list.getBoundingClientRect().left)
            - gutter;
        list.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }
}
